import { render, staticRenderFns } from "./EmbedCard.vue?vue&type=template&id=61f68a0f&"
import script from "./EmbedCard.vue?vue&type=script&lang=js&"
export * from "./EmbedCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports